/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Trial_NoteInputs */



/**
* | output |
* | --- |
* | "No payment required for 7 days" |
*
* @param {Signup_Trial_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_trial_note = /** @type {((inputs?: Signup_Trial_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Trial_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun paiement requis pendant 7 jours")
	if (locale === "de") return /** @type {LocalizedString} */ ("7 Tage lang keine Zahlung erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun pagamento richiesto per 7 giorni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оплата не требуется в течение 7 дней.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se requiere pago durante 7 días")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("7天内无需付款")
	if (locale === "ja") return /** @type {LocalizedString} */ ("7日間は支払い不要")
	if (locale === "hi") return /** @type {LocalizedString} */ ("7 दिनों तक कोई भुगतान आवश्यक नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum pagamento é necessário por 7 dias.")
	return /** @type {LocalizedString} */ ("No payment required for 7 days")
});